import firebase from '@/firebase';

const state = {
    // dev only
    exercisesFetched: false,
    exercises: [],
    premiumExerciseSnips: [],
};


const getters = {
    getExercises: state => state.exercises.sort((a, b) => a.completed - b.completed),
    isExercisesFetched: state => state.exercisesFetched,
    getPremiumSnips: state => state.premiumExerciseSnips,
    getPremiumExercises: state => state.premiumExercises,
}

const mutations = {
    setExercises: (state, exercises) => state.exercises = [...state.exercises, ...exercises],
    switchExercisesFetch: state => {
        if (state.exercisesFetched) {
            state.exercises = []
            state.premiumExerciseSnips = []
        }
        state.exercisesFetched = !state.exercisesFetched
    },
    clearExercises: state => {
        state.exercisesFetched = false
        state.exercises = []
    },
    setPremiumExercisesSnips: (state, payload) => state.premiumExerciseSnips = payload,
    setPremiumExercises: (state, payload) => state.exercises = [...state.exercises, ...payload],
    resetExercises: (state, payload) => {
        state.exercisesFetched = false;
        state.exercises = [];
        state.premiumExerciseSnips = [];
    }
}

const actions = {
    fetchExercises: async ({ commit, rootState: { auth: { userDetails: { grade, exerciseCompletedIds, premium } } } }) => {
        const exercises =
            await firebase
                .firestore()
                .collection('exercises')
                .where('availableFor', 'array-contains', grade)
                .where('premium', '==', false)
                .get();
        function transformExercises(exercises) {
            const tempEx = [];
            exercises.docs.forEach(ex => {
                const questions = [];
                const exData = ex.data();

                // looping ques
                for (let q in exData.questions) {

                    const ops = [];
                    for (let op in exData.questions[q].ops) {
                        ops.push({
                            opId:
                                Number(op), op: exData.questions[q].ops[op]
                        })
                    }

                    questions.push({
                        ...exData.questions[q],
                        ques: q,
                        ops,
                    });
                }

                tempEx.push({
                    ...exData,
                    questions,
                    completed: exerciseCompletedIds.some(ex => ex === exData.exerciseId)
                })
            });
            return tempEx
        }

        if (!premium) {
            const premiumExercisesSnips = await firebase.firestore().collection('premiumExerciseSnips').where('availableFor', 'array-contains', grade).get();
            const pe = [];
            if (!premiumExercisesSnips.empty) {
                premiumExercisesSnips.docs.forEach(e => pe.push(e.data()));
            }
            commit('setPremiumExercisesSnips', pe);
        } else {
            const premiumExercises = await firebase.firestore().collection('exercises').where('availableFor', 'array-contains', grade).where('premium', '==', true).get()
            if (!premiumExercises.empty) {
                const premiumExer = transformExercises(premiumExercises);
                commit('setPremiumExercises', premiumExer);
            }
        }

        const freeExer = transformExercises(exercises);

        commit('setExercises', freeExer)
        commit('switchExercisesFetch')
    },
    submitExercise: async ({ commit }, payload) => {
        return await firebase.functions().httpsCallable('exerciseSubmit')(payload)
    }
}


export default {
    state,
    getters,
    mutations,
    actions
}